(() => {
  const labels = window.frostlyMobileLabels || { maker: 'Maker', colour: 'Colour' };
  function enhance(root = document) {
    root.querySelectorAll('.quantity-break__selector-item').forEach(row => {
      const select = row.querySelector('select');
      if (!select || select.dataset.frostlyEnhanced || row.querySelectorAll('select').length !== 1) return;
      const options = [...select.options];
      if (!options.length || options.length > 4) return;
      select.dataset.frostlyEnhanced = 'true';
      const group = document.createElement('div');
      group.className = 'fr-colour-buttons';
      group.setAttribute('role', 'group');
      const number = row.querySelector('.quantity-break__selector-item__number');
      const index = Number(row.dataset.selectIndex || 0) + 1;
      if (number) number.textContent = Number(row.closest('.quantity-break')?.dataset.quantity) === 1 ? labels.colour : `#${index}`;
      group.setAttribute('aria-label', `${labels.colour} — ${labels.maker} ${index}`);
      options.forEach(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'fr-colour-button';
        button.dataset.value = option.value;
        button.disabled = option.disabled;
        const dot = document.createElement('span');
        dot.className = 'fr-colour-dot';
        dot.setAttribute('aria-hidden', 'true');
        dot.style.backgroundColor = option.value.toLowerCase() === 'pink' ? '#efb8c8' : option.value.toLowerCase() === 'mint' ? '#b8d7cb' : '#ddd';
        button.append(dot, document.createTextNode(option.textContent.trim()));
        button.addEventListener('click', () => {
          if (select.value === option.value) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          update();
        });
        group.append(button);
      });
      function update() {
        group.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.value === select.value)));
      }
      select.addEventListener('change', update);
      row.append(group);
      row.classList.add('fr-colours-ready');
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  const target = document.getElementById('MainContent');
  if (target) new MutationObserver(() => enhance(target)).observe(target, { childList: true, subtree: true });
})();

(() => {
  const careStates = new Map();
  function attachCare(root = document) {
    root.querySelectorAll('quantity-breaks').forEach(bundles => {
      if (bundles.dataset.careAttached) return;
      const product = bundles.closest('.product__info-container');
      const source = product?.querySelector('.fr-extra-options');
      if (!source) return;
      const purchase = product.querySelector('product-form');
      if (!purchase) return;
      bundles.dataset.careAttached = 'true';
      {
        const panel = document.createElement('div');
        panel.className = 'fr-order-care';
        source.querySelectorAll('.fr-extra-option').forEach(option => {
          const row = document.createElement('div');
          row.className = 'fr-attached-care-row';
          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'fr-care-toggle';
          toggle.setAttribute('role', 'checkbox');
          toggle.setAttribute('aria-checked', String(careStates.get(option.dataset.variantId) ?? true));
          toggle.dataset.variantId = option.dataset.variantId || '';
          toggle.dataset.price = option.dataset.price || '0';
          toggle.setAttribute('aria-label', option.querySelector('strong')?.textContent || 'Care option');
          toggle.innerHTML = '<span aria-hidden="true">✓</span>';
          toggle.addEventListener('click', event => {
            event.stopPropagation();
            const next = toggle.getAttribute('aria-checked') !== 'true';
            careStates.set(toggle.dataset.variantId, next);
            document.querySelectorAll('.fr-care-toggle').forEach(other => {
              if (other.dataset.variantId === toggle.dataset.variantId) other.setAttribute('aria-checked', String(next));
            });
            document.dispatchEvent(new Event('frostly:care-change'));
          });
          const name = document.createElement('strong');
          name.textContent = option.dataset.shortName || option.querySelector('strong')?.textContent || '';
          const price = document.createElement('span');
          price.className = 'fr-attached-care-price';
          price.textContent = option.querySelector('.fr-extra-cost')?.textContent || '';
          const icon = document.createElement('span');
          icon.className = 'fr-care-icon';
          icon.setAttribute('aria-hidden', 'true');
          if (option.dataset.image) {
            const image = document.createElement('img');
            image.src = option.dataset.image;
            image.alt = '';
            image.width = 56;
            image.height = 56;
            image.loading = 'lazy';
            icon.append(image);
          }
          const text = document.createElement('div');
          text.append(name);
          const terms = document.createElement('a');
          terms.className = 'fr-care-terms';
          terms.textContent = window.frostlyMobileLabels?.details || 'Details';
          terms.href = option.dataset.terms;
          terms.addEventListener('click', event => event.stopPropagation());
          text.append(terms);
          row.append(icon, text, price, toggle);
          row.addEventListener('click', event => {
            if (event.target.closest('button, a')) return;
            event.preventDefault();
            event.stopPropagation();
            toggle.click();
          });
          panel.append(row);
        });
        purchase.after(panel);
      }
      source.hidden = true;
      bundles.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        document.dispatchEvent(new Event('frostly:care-change'));
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => attachCare());
  else attachCare();
  document.addEventListener('shopify:section:load', event => attachCare(event.target));
  const root = document.getElementById('MainContent');
  if (root) new MutationObserver(() => attachCare(root)).observe(root, { childList: true, subtree: true });
})();

